module.exports = __webpack_public_path__ + "static/media/cake-1.07a87f00.svg";